import { authGet } from "@api/auth/auth";
import { DEPLOYMENT_URL } from "@constants";
import { FindingCounts } from "@types";

export const fetchFindingCounts = (
  deploymentId: string,
  search: URLSearchParams
): Promise<FindingCounts> => {
  return authGet<FindingCounts>(
    `${DEPLOYMENT_URL}/${deploymentId}/issue_counts?${search.toString()}`
  );
};
